import { render } from "./PerformancePerInvestmentChart.vue?vue&type=template&id=63504605&ts=true"
import script from "./PerformancePerInvestmentChart.vue?vue&type=script&lang=ts"
export * from "./PerformancePerInvestmentChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__